import moment from 'moment';
import { useEffect } from 'react';

export const useDefaultLocale = () => {
    useEffect(() => {
        moment.locale("en");
    }, []);
};
